import { Flex, FormControl, FormErrorMessage, FormLabel, HStack, InputGroup, InputRightElement, Select, Spinner, VStack } from "@chakra-ui/react";
import { FieldErrors, FieldValues, UseFormRegister } from "react-hook-form";

import { G1Country } from "@bcasmart/doxecure-commons/doxecureLocales";
import { $length, $ok } from "foundation-ts/commons";

import { G1Input } from "@components/G1Input";
import { $g1Color } from "@/theme/G1Style";
import { Component } from "@/utils/TypesAndConstants";

type AddressFormProperties<T extends FieldValues> = {
    required: boolean ;
    disabled?: boolean ;
    countries?: G1Country[] ;
    component?: Component;
    prepId?: string ;
    firstPosition?: boolean ;
    displayCountry?: boolean ;
    city?: string;
    isSearchInProgress?: boolean;
    errors: FieldErrors<T> ;
    register: UseFormRegister<T> ;
    onChange: (e: any) => void ;
};

export type AddressFormValues = {
    city: string,
    country: string,
    streetNumber?: string,
    street?: string,
    streetComplement?: string,
    zipCode?: string
} ;

export const AddressForm = (props: AddressFormProperties<FieldValues>) => {
    const { prepId, required, disabled, firstPosition, displayCountry = true, countries, component, city, isSearchInProgress, errors, register, onChange } = props ;
    const nameStreetNumber = `${$ok(prepId) ? prepId : ""}streetNumber` ;
    const nameStreet = `${$ok(prepId) ? prepId : ""}street` ;
    const nameStreetComplement = `${$ok(prepId) ? prepId : ""}streetComplement` ;
    const nameZipCode = `${$ok(prepId) ? prepId : ""}zipCode` ;
    const nameCity = `${$ok(prepId) ? prepId : ""}city` ;
    const nameCountry = `${$ok(prepId) ? prepId : ""}country` ;

   const spinnerEl = !!isSearchInProgress ? (
        <InputRightElement>
            <Spinner size="sm" color="gray.500" />
        </InputRightElement>
    ) : null;

    return (
        <FormControl isRequired={required} isDisabled={disabled} isInvalid={$ok(errors[nameCity])} marginTop={firstPosition ? 0 : 3}>
            <FormLabel fontSize="1.25em">Adresse</FormLabel>
            <VStack width="100%" spacing="3" align="stretch">
                <HStack>
                    <InputGroup width="30%" >
                        <G1Input component={component || "form"} id={nameStreetNumber} registerInput={{ ...register(nameStreetNumber) }} width="100%" placeholder="No" onChange={onChange} />
                        { spinnerEl }
                    </InputGroup>
                    <InputGroup>
                        <G1Input component={component || "form"} id={nameStreet} registerInput={{ ...register(nameStreet) }} placeholder="Rue" onChange={onChange} />
                        { spinnerEl }
                    </InputGroup>
                </HStack>

                <InputGroup>
                    <G1Input component={component || "form"}id={nameStreetComplement} registerInput={{ ...register(nameStreetComplement) }} marginBottom="2%" width="100%" placeholder="Complément d'adresse" onChange={onChange} />
                    { spinnerEl }
                </InputGroup>
                <HStack align="flex-start">
                    <InputGroup width="40%">
                        <G1Input component={component || "form"} id={nameZipCode} registerInput={{ ...register(nameZipCode) }} placeholder="Code postal" width="100%" maxLength={6} onChange={onChange} />
                        { spinnerEl }
                    </InputGroup>
                    <Flex direction="column" width="100%">
                        <InputGroup>
                            <G1Input component={component || "form"} id={nameCity} registerInput={{ ...register(nameCity, { required: required, pattern: /^[a-zàâäéèêëïîôöùûüç]+([ '-][a-zàâäéèêëïîôöùûüç]+)*$/i }) }} placeholder="Ville" textTransform="uppercase" isRequired onChange={onChange} />
                            { spinnerEl }
                        </InputGroup>
                        <FormErrorMessage color="red.200">La ville est {$length(city) === 0 ? "requise" : "invalide"}</FormErrorMessage>
                    </Flex>
                </HStack>
                {displayCountry &&
                    <Select id={nameCountry} {...register(nameCountry)} bg={$g1Color(($ok(component) ? component : 'form')+'.field.bg')} borderColor={$g1Color(($ok(component) ? component : 'form')+'.field.border')} isRequired autoComplete="true" defaultValue={countries?.first()?.code} onChange={onChange}>
                        {countries?.map((country) => (
                            <option value={country.code} key={country.code}>
                                {country.name}
                            </option>
                        ))}
                    </Select>
                }
            </VStack>
        </FormControl>
    ) ;
} ;